import {
  Component,
  OnInit,
  ViewEncapsulation,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { DataService } from "../../../shared/services/municipios.service";
import { BancosServices } from "../../../shared/services/bancos.service";
import { CargosService } from "../../../shared/services/cargos.service";
import { EmpresasService } from "../../../shared/services/empresas.service";
import { CivilService } from "../../../shared/services/civil.service";
import { PropietarioService } from "../../../shared/services/propietarios.service";
import { RazaService } from "../../../shared/services/raza..service";
import { NucleoFamiliarService } from "../../../shared/services/nucleofamiliar.service";
import { AreaService } from "../../../shared/services/area.service";
import { TipoContratoService } from "../../../shared/services/tipocontrato.service";
import { SeguridadSocialService } from "../../../shared/services/seguridadsocial.service";
import { Propietario } from "../../../shared/model/propietario";
import { NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import { NgbAccordion } from "@ng-bootstrap/ng-bootstrap";
import { CondicionService } from "../../../shared/services/condicion.services";
import { NgForm } from '@angular/forms';
import { TipoViviendaService } from "../../../shared/services/tipoVivienda.services";
import { forkJoin } from 'rxjs';
import { FirmasComponent } from "../../firmas/firmas/firmas.component";
import { TipoDocumentoService } from "../../../shared/services/tipodocumento.service";
import Swal from "sweetalert2";

@Component({
  selector: "app-personas",
  templateUrl: "./personas.component.html",
  styleUrls: ["./personas.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class PersonasComponent implements OnInit {
  activePanel: string[] = ["static-1"]; // El panel se abre por defecto
  fechaMaximaPermitida!: string;
  dataRaza: any;
  areaData!: any[];
  tipocontratoData!: any[];
  seguridadsocialData!: any[];
  form: any;
  Tiposdocumentos!: any[];

async togglePanel(panelId: string) {
    // Si está en el panel de Datos Básicos y va a cambiar, guardar firma automáticamente
    if (this.activePanel.includes('static-1') && panelId !== 'static-1') {
      console.log('🔄 Cambiando de panel - Guardando firma automáticamente...');
      if (this.firmasComponent && this.formData.cedula) {
        try {
          await this.firmasComponent.guardarFirma(true); // true = modo silencioso
          console.log('✅ Firma guardada automáticamente');
        } catch (error) {
          console.log('⚠️ No se pudo guardar firma (puede estar vacía)');
        }
      }
    }
    
    this.activePanel = this.activePanel.includes(panelId) ? [] : [panelId];
  }

  soloLetras(event: KeyboardEvent) {
    const charCode = event.key;
    const pattern = /^[A-Za-zÁÉÍÓÚáéíóúÑñ\s]+$/;

    if (!pattern.test(charCode)) {
      event.preventDefault(); // Bloquea el ingreso de caracteres no permitidos
    }
  }
  @ViewChild("inputTipo") inputTipo!: ElementRef;
  @ViewChild("inputCedula") inputCedula!: ElementRef;
  @ViewChild("inputPrimernombre") inputPrimernombre!: ElementRef;
  @ViewChild("inputFechanacimiento") inputFechanacimiento!: ElementRef;
  @ViewChild("inputPapellidos") inputPapellidos!: ElementRef;
  @ViewChild("inputGenero") inputGenero!: ElementRef;
  @ViewChild("inputEstadocivil") inputEstadocivil!: ElementRef;
  @ViewChild("inputEstratos") inputEstratos!: ElementRef;
  @ViewChild("inputRaza") inputRaza!: ElementRef;
  @ViewChild("inputTipodevivienda") inputTipodevivienda!: ElementRef;
  @ViewChild("inputCargos") inputCargos!: ElementRef;
  @ViewChild("inputCategoria") inputCategoria!: ElementRef;
  @ViewChild("inputNumerolic") inputNumerolic!: ElementRef;
  @ViewChild("inputExpedicioLic") inputExpedicioLic!: ElementRef;
  @ViewChild("inputFechaVenceLic") inputFechaVenceLic!: ElementRef;
  @ViewChild("inputGmail") inputGmail!: ElementRef;
  @ViewChild('inputCondicion', { static: false }) inputCondicion!: ElementRef;
  @ViewChild('miFormulario') miFormulario!: NgForm;
  @ViewChild("accordion", { static: false }) accordion!: NgbAccordion;
  @ViewChild(FirmasComponent, { static: false }) firmasComponent!: FirmasComponent;																				   
  

  errores: any = {
      cargo: '',
      categoria: '',
  };
  municipios: any[] = []; // Arreglo donde almacenaremos los municipios
  bancos: any[] = [];
  datacargos: any[] = [];
  datacondicion: any[] = [];
  todasLasEmpresas: any[] = [];
  empresas: any[] = [];
  empresaARL:any[] = [];
  empresaAFP:any[] = [];
  empresaCES:any[] = [];
  empresaCCF:any[] = [];
  dataCiviles!: any[];
  formData: any = {
  };
  datos!: any[];
  fechaVenceLic!: Date;
  fechanacimiento!: Date;
  FirmaContrato!: Date;
  VenceContrato!: Date;
  FechaEps!: Date;
  FechaCobEps!: Date;
  FechaArl!: Date;
  FechaCobArl!: Date;
  FechaAfp!: Date;
  FechaCobAfp!: Date;
  FechaCes!: Date;
  FechaCobCes!: Date;
  FechaCcf!: Date;
  FechaCobEccf!: Date;
  ExpedicioLic!: Date;
  FechaPonal!: Date;
  FechaProcu!: Date;

  public validate = false;
  public tooltipValidation = false;

  public tooltipSubmit() {
    this.tooltipValidation = !this.tooltipValidation;
  }

  public TipoDeDocumento = [
    { value: "NIT", label: "NIT" },
    { value: "CC", label: "CEDULA DE CIUDADANIA" },
    { value: "CE", label: "CEDULA DE EXTRANJERIA" },
    { value: "PA", label: "PASAPORTE" },
    { value: "OTRO", label: "OTRO" },
  ];
  public Documento!: string; // Aquí se almacena el valor seleccionado del <ng-select>

  public Genero = [
    { value: "1", label: "MASCULINO" },
    { value: "2", label: "FEMENINO" },
  ];
  public Gene!: string;

  public TipoDeSangre = [
    { value: "A+", label: "A+" },
    { value: "A-", label: "A-" },
    { value: "B+", label: "B+" },
    { value: "B-", label: "B-" },
    { value: "AB+", label: "AB+" },
    { value: "AB-", label: "AB-" },
    { value: "O+", label: "O+" },
    { value: "O-", label: "O-" },
  ];
  public Sangre!: string;

  public Estrato = [
    { value: "0", label: "NO SELECCIONADO" },
    { value: "1", label: "1" },
    { value: "2", label: "2" },
    { value: "3", label: "3" },
    { value: "4", label: "4" },
    { value: "5", label: "5" },
    { value: "6", label: "6" },
    { value: "7", label: "7" },
    { value: "8", label: "8" },
  ];
  public Estra!: string;

  public TipoDeCuenta = [
    { value: "1", label: "AHORROS" },
    { value: "2", label: "CORRIENTE" },
    { value: "3", label: "OTRA" },
  ];
  public Cuenta!: string;



  TipoDeVivienda: any[] = [];
  public Vivienda!: string;

  public NucleoFamiliar: any[] = [];

  public Nucleo!: string;

  public PadreFamiliar = [
    { value: "SI", label: "SI" },
    { value: "NO", label: "NO" },
  ];
  public Padre!: string;

  onPadreChange() {
    if (this.formData.padre === "1") {
    } else {
      this.formData.numeroHijos = 0;
    }
  }


  public Perfil = [
    { value: "1", label: "ADMIN" },
    { value: "2", label: "HUMANAS" },
  ];
  public perfil!: string;


  public JornadaLaboral = [
    { value: "DIURNA", label: "DIURNA" },
    { value: "NOCTURNA", label: "NOCTURNA" },
    { value: "MIXTA", label: "MIXTA" },
  ];
  public jornada!: string; 
  public eps!: string; 
  public arl!: string; 
  public Fondo!: string; 
  public compensacion!: string;

  public Categoria = [
    { value: "1", label: "MOTOS", disabled: true },
    { value: "A1", label: "A1" },
    { value: "A2", label: "A2" },

    { value: "4", label: "SERVICIO PARTICULAR", disabled: true },
    { value: "B1", label: "B1" },
    { value: "B2", label: "B2" },
    { value: "B3", label: "B3" },

    { value: "8", label: "SERVICIO PUBLICO", disabled: true },
    { value: "C1", label: "C1" },
    { value: "C2", label: "C2" },
    { value: "C3", label: "C3" },

    { value: "12", label: "TRANSPORTE FLUVIAL", disabled: true },
    { value: "TRIPULANTE MOTORISTA", label: "TRIPULANTE MOTORISTA" },
    { value: "TRIPULANTE AYUDANTE FLUVIAL", label: "TRIPULANTE AYUDANTE FLUVIAL" },
    { value: "NO TIENE", label: "NO TIENE" },
  ];
  public categoria!: string;

  public ResultadoPonal = [
    { value: "1", label: "SIN ANTECEDENTES" },
    { value: "2", label: "CON ANTECEDENTES" },
  ];
  public Resultado!: string;

  public detalleAntecedentesPonal: string = "";
  public detalleAntecedentesProcu: string = "";

  onChangeResultado(tipo: string) {
    if (tipo === "ponal" && this.formData.resultadoponal !== "2") {
      this.detalleAntecedentesPonal = ""; // Borra si cambia la opción en PONAL
    }
    if (tipo === "procuraduria" && this.formData.resultadoprocu !== "2") {
      this.detalleAntecedentesProcu = ""; // Borra si cambia la opción en PROCURADURIA
    }
  }

  onCargoChange() {
    console.log("Cargo seleccionado:", this.formData.cargo);
  
    if (this.formData.cargo !== '2') {
      this.formData.categoria = ''; // Borra la categoría si cambia de cargo
    }
  }

  public counter: number[] = [
    18, 40, 55, 40, 40, 40, 20, 40, 50.0, 40, 40, 50, 50, 40, 60, 40,
  ];
  public contents = ["Action", "Another Action", "Something Else Here"];



  files: any[] = [];
  cedulaFrontal: File[] = [];
  cedulaPosterior: File[] = [];
  licenciaFrontal: File[] = [];
  licenciaPosterior: File[] = [];

onSelect(event: any, type: string) {
    const file = event.addedFiles[0]; // Solo permite un archivo por dropzone
    if (!file) return;
  
    if (!file.type.startsWith('image/')) {
      console.error("El archivo seleccionado no es una imagen.");
      return;
    }
  
    const fileWithPreview = {
      file: file,
      name: file.name,
      type: file.type,
      preview: ''
    };
  
    const reader = new FileReader();
    reader.onload = () => {
      fileWithPreview.preview = reader.result as string;
    //  console.log("Vista previa generada:", fileWithPreview.preview);
      this.updateFileList(fileWithPreview, type);
    };
    reader.readAsDataURL(file);
  }
  
  fechaCreacion?: Date;

  updateFileList(fileWithPreview: any, type: string) {
    switch (type) {
      case 'cedulaFrontal':
        this.cedulaFrontal = [fileWithPreview];
        break;
      case 'cedulaPosterior':
        this.cedulaPosterior = [fileWithPreview];
        break;
      case 'licenciaFrontal':
        this.licenciaFrontal = [fileWithPreview];
        break;
      case 'licenciaPosterior':
        this.licenciaPosterior = [fileWithPreview];
        break;
    }
  }

  onRemove(file: any, type: string) {
    switch (type) {
      case 'cedulaFrontal':
        this.cedulaFrontal = [];
        break;
      case 'cedulaPosterior':
        this.cedulaPosterior = [];
        break;
      case 'licenciaFrontal':
        this.licenciaFrontal = [];
        break;
      case 'licenciaPosterior':
        this.licenciaPosterior = [];
        break;
    }
  }


  constructor(
    private dataService: DataService,
    private bancosService: BancosServices,
    private cargosService: CargosService,
    private empresasService: EmpresasService,
    private propietarioService: PropietarioService,
    private condicionSerivice: CondicionService,
    private civilService: CivilService,
    private tipoDocumentoService: TipoDocumentoService,
    private razaService: RazaService,
    private nucleoFamiliarService: NucleoFamiliarService,
    private areaService: AreaService,
    private tipocontratoService: TipoContratoService,
    private seguridadsocialservice: SeguridadSocialService,
    private tipoViviendaService: TipoViviendaService,
  ) {
    this.formData = {
      tipo: "",
      cedula: "",
      primernombre: "",
      papellidos: "",
      fechaCreacion: new Date(),
    };
  }

 

  ngOnInit(): void {
   this.obtenerTiposVivienda();
    this.cargarDatos();
    this.calcularFechaMaxima();   
      
  }




  
   // Cargar todos los datos de las APIs en paralelo
   private cargarDatos(): void {
    forkJoin({
      municipios: this.dataService.getDatos(),
      bancos: this.bancosService.getBancos(),
      datacondicion: this.condicionSerivice.getAllCondicion(),
      datacargos: this.cargosService.getCargosActivos(),
      dataCiviles: this.civilService.getCiviles(),
      dataRaza: this.razaService.getRazas(),
      NucleoFamiliar: this.nucleoFamiliarService.getNucleosFamiliares(),
      areaData: this.areaService.getAreas(),
      tipocontratoData: this.tipocontratoService.getTiposContrato(),
      seguridadsocialData: this.seguridadsocialservice.getSeguridadSocial(),
      empresas:  this.empresasService.getEPS(),
      empresaARL: this.empresasService.getARL(),
      empresaAFP: this.empresasService.getAFP(),
      empresaCES: this.empresasService.getCES(),
      empresaCCF: this.empresasService.getCCF(),
      tiposdocumentos: this.tipoDocumentoService.getTiposDocumento()
    }).subscribe(
      (resultados) => {
        this.municipios = resultados.municipios;
        this.bancos = resultados.bancos;
        this.datacondicion = resultados.datacondicion;
        this.datacargos = Array.isArray(resultados.datacargos)
          ? resultados.datacargos
          : resultados.datacargos?.todos ?? resultados.datacargos?.cargos ?? resultados.datacargos?.data ?? [];
        this.dataCiviles = resultados.dataCiviles;
        this.dataRaza = resultados.dataRaza;
        this.NucleoFamiliar = resultados.NucleoFamiliar;
        this.areaData = resultados.areaData;
        this.tipocontratoData = resultados.tipocontratoData;
        this.seguridadsocialData = resultados.seguridadsocialData;
        this.empresas = resultados.empresas;
        this.empresaARL = resultados.empresaARL;
        this.empresaAFP = resultados.empresaAFP;
        this.empresaCES = resultados.empresaCES;
        this.empresaCCF = resultados.empresaCCF;
      },
      (error) => this.handleError(error)
    );
  }

   // Manejo de errores genérico
   private handleError(error: any): void {
    console.error('Error al obtener datos:', error);
  }

   // Calcular la fecha máxima permitida (mínimo 18 años)
   private calcularFechaMaxima(): void {
    const hoy = new Date();
    const fechaMinima = new Date(hoy.getFullYear() - 18, hoy.getMonth(), hoy.getDate());
    this.fechaMaximaPermitida = fechaMinima.toISOString().split("T")[0];
  }
  calcularIMC() {
    const peso = this.formData.peso;
    const alturaCM = this.formData.altura;

    if (!peso || !alturaCM || alturaCM <= 0) {
      this.formData.imc = "";
      this.formData.resultadoimc = "";
      return;
    }

    const alturaM = alturaCM / 100; // Convertir la altura a metros
    const imc = peso / (alturaM * alturaM);

    this.formData.imc = imc.toFixed(2); // Guardar el IMC con dos decimales

    // Determinar el resultado del IMC
    if (imc < 18.5) {
      this.formData.resultadoimc = "Bajo peso";
    } else if (imc >= 18.5 && imc < 24.9) {
      this.formData.resultadoimc = "Peso normal";
    } else if (imc >= 25 && imc < 29.9) {
      this.formData.resultadoimc = "Sobrepeso";
    } else {
      this.formData.resultadoimc = "Obesidad";
    }
  }

  calcularEdad(fechaNacimiento: string) {
    if (!fechaNacimiento || fechaNacimiento.length !== 10) {
      console.error("Fecha de nacimiento inválida:", fechaNacimiento);
      return;
    }
  
    const [year, month, day] = fechaNacimiento.split("-").map(Number);
    if (isNaN(year) || isNaN(month) || isNaN(day)) {
      console.error("Error al extraer año, mes y día:", { year, month, day });
      return;
    }
  
    const fechaNac = new Date(year, month - 1, day);
    const hoy = new Date();
    const fechaMinima = new Date(hoy.getFullYear() - 18, hoy.getMonth(), hoy.getDate());
  
    if (fechaNac > hoy) {
      //console.error("No se pueden seleccionar fechas futuras.");
      Swal.fire({
        title: "Importante",
        text: "No se pueden seleccionar fechas futuras.",
        icon: "warning",
        confirmButtonText: "Aceptar",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
      });
    //  alert("No se pueden seleccionar fechas futuras.");
      this.formData.fechanacimiento = "";
      this.formData.edad ="";
      return;
    }
  
    if (fechaNac > fechaMinima) {
      //console.error("Debe ser mayor de 18 años.");
      // alert("Debe ser mayor de 18 años.");
      this.formData.fechanacimiento = "";
      this.formData.edad ="";
       Swal.fire({
        title: "info",
        text: "La fecha de nacimiento debe ser mayor 18 años",
        icon: "warning",
        confirmButtonText: "Aceptar",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
      });

      return;
    
    }
  
    let edad = hoy.getFullYear() - fechaNac.getFullYear();
    if (hoy.getMonth() < fechaNac.getMonth() || 
       (hoy.getMonth() === fechaNac.getMonth() && hoy.getDate() < fechaNac.getDate())) {
      edad--;
    }
  
    this.formData.edad = edad;
    console.log(`Edad calculada correctamente: ${edad}`);
  }
  
  validarTelefono(event: any) {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/\D/g, ''); // Elimina todo lo que no sea número
    this.formData.telfijo = input.value.slice(0, 10); // Limita a 10 dígitos
  }

  validarTelefonoCelular(event: any) {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/\D/g, ''); // Elimina todo lo que no sea número
    this.formData.telcel = input.value.slice(0, 10); // Limita a 10 dígitos
  }

  validarteleempresa(event: any) {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/\D/g, ''); // Elimina todo lo que no sea número
    this.formData.telempresa = input.value.slice(0, 10); // Limita a 10 dígitos
  }
  
  
  

  createPropietario() {
    
    const propietario: Propietario = {
      tipo: this.formData.tipo || "",
      cedula: this.formData.cedula,
      lugarex: this.formData.lugarex || null,
      primernombre: this.formData.primernombre || "",
      segundonombre: this.formData.segundonombre || null,
      papellidos: this.formData.papellidos || "",
      seapellidos: this.formData.seapellidos || null,
      fechanace: this.formData.fechanacimiento,
      edad: this.formData.edad || 0,
      lugarnace: this.formData.lugarnace || null,
      genero: this.formData.genero || null,
      civil: this.formData.civil  || 0,
      sangre: this.formData.sangre || "",
      direccion: this.formData.direccion || "",
      ciudad: this.formData.ciudad || null,
      barrio: this.formData.barrio || "",
      estrato: this.formData.estrato || 0,
      telfijo: this.formData.telfijo || "",
      telcel: this.formData.telcel || "",
      telempresa: this.formData.telempresa || "",
      mail: this.formData.mail || "",
      banco: this.formData.banco || null,
      tipocuenta: this.formData.tipocuenta || "",
      cuenta: this.formData.cuenta || "",
      raza: this.formData.raza  || 0,
      vivienda: this.formData.vivienda  || 0,
      nucleo: this.formData.nucleo || null,
      padre: this.formData.padre || "",
      nhijos: this.formData.nhijos || 0,
      area: this.formData.area || null,
      password: this.formData.password || "",
      observaciones: this.formData.observaciones || "",
      condicion: this.formData.condicion || "",
      cargo: this.formData.cargo || "",
      tipocontrato: this.formData.tipocontrato || null,
      jornada: this.formData.jornada || "",
      firmacontrato: this.formData.FirmaContrato,
      vencecontrato: this.formData.VenceContrato,
      lugartrabajo: this.formData.lugartrabajo || null,
      sueldo: this.formData.sueldo || 0,
      asumess: this.formData.asumess || null,
      camisa: this.formData.camisa || "",
      pantalon: this.formData.pantalon || "",
      zapatos: this.formData.zapatos || "",
      peso: this.formData.peso || 0,
      altura: this.formData.altura || 0,
      imc: this.formData.imc || 0,
      resultadoimc: this.formData.resultadoimc || "",
      eps: this.formData.eps || "",
      fechaeps: this.formData.FechaEps,
      fechacobeps: this.formData.FechaCobEps,
      arl: this.formData.arl || "",
      fechaarl: this.formData.FechaArl,
      fechacobarl: this.formData.FechaCobArl,
      afp: this.formData.afp || "",
      fechaafp: this.formData.FechaAfp,
      fechacobafp: this.formData.FechaCobAfp,
      ces: this.formData.ces || "",
      fechaces: this.formData.FechaCes,
      fechacobces: this.formData.FechaCobCes,
      ccf: this.formData.ccf || "",
      fechaccf: this.formData.FechaCcf,
      fechacobeccf: this.formData.FechaCobEccf,
      categoria: this.formData.categoria || "",
      numerolic: this.formData.numerolic || "",
      expediciolic: this.formData.ExpedicioLic,
      vencelic: this.formData.fechaVenceLic,
      fechaponal: this.formData.FechaPonal,
      resultadoponal: this.formData.resultadoponal || "",
      anteponal: this.formData.anteponal || "",
      anteprocu: this.formData.anteprocu || "",
      fechaprocu: this.formData.FechaProcu,
      resultadoprocu: this.formData.resultadoprocu || "",

      existe: false,
      fechaNacimiento: ""
    };
    

   // console.log(propietario);

    this.propietarioService.createPropietario(propietario).subscribe(
      async (response) => {
      //  console.log("Datos guardados:", response);
        
        // Intentar guardar la firma si existe
        let firmaGuardada = false;
        if (this.firmasComponent && this.firmasComponent.tieneFirma()) {
          try {
            firmaGuardada = await this.firmasComponent.guardarFirma(true); // true = silencioso
            console.log('Firma guardada automáticamente');
          } catch (error) {
            console.error('Error al guardar firma automáticamente:', error);
          }
        }
        
        //alert("Datos guardados con éxito");
        Swal.fire({
          icon: 'success',
          title: '¡Éxito!',
          text: firmaGuardada ? 'Persona y firma guardadas correctamente.' : 'Persona creada correctamente.',
          confirmButtonText: 'Aceptar',
           timer: 1500,
        });
        
        // Resetear formulario y limpiar archivos
        this.resetForm();
        this.errores = {};
        this.cedulaFrontal = [];
        this.cedulaPosterior = [];
        this.licenciaFrontal = [];
        this.licenciaPosterior = [];
        
        setTimeout(() => {
          location.reload();
        }, 500);
      },
      (error) => {
        
        Swal.fire({
                  icon: 'error',
                  title: '¡Error!',
                  text: `${error.message || error}`,
                  confirmButtonText: 'Aceptar'
                });
        //console.log("Error al guardar los datos:", error);
        //alert(`Error al guardar los datos: ${error.message || error}`);
      }
    );
  }

  fechaMaximaExpedicion: string = new Date().toISOString().split('T')[0];
  fechaMinimaPermitida: string = new Date().toISOString().split('T')[0];
  
  onDateChange(fechaObj: any, campo: string) {
    if (!fechaObj) {
      console.error("fechaObj está vacío:", fechaObj);
      return;
    }
  
    const fechaConvertida = this.convertirFecha(fechaObj);
    if (!fechaConvertida) {
      console.error("Error al convertir la fecha:", fechaObj);
      return;
    }
  
    const hoy = new Date();
    const fechaHoy = hoy.toISOString().split("T")[0]
    const fechaSeleccionada = new Date(fechaConvertida);
  
    if (campo === "vencecontrato" && fechaSeleccionada <= hoy) {
      console.error("Error: Ingrese una fecha futura.");
      alert("Ingrese una fecha futura.");
      this.formData[campo] = "";
      return;
    }
  
    if (campo === "expediciolic" && fechaSeleccionada >= hoy) {
      console.error("Error: Ingrese una fecha pasada.");
      alert("Ingrese una fecha pasada.");
      this.formData[campo] = "";
      return;
    }
  
    this.formData[campo] = fechaConvertida;
  
    if (campo === "fechanace") {
      this.calcularEdad(fechaConvertida);
    }
  }
  
  
  
  
  actualizarFechas(fechaConvertida: string, campo: string) {
    const camposFecha = [
      "fechaVenceLic",
      "fechanace",
      "FirmaContrato",
      "VenceContrato",
      "FechaEps",
      "FechaCobEps",
      "FechaArl",
      "FechaCobArl",
      "FechaAfp",
      "FechaCobAfp",
      "FechaCes",
      "FechaCobCes",
      "FechaCcf",
      "FechaCobEccf",
      "ExpedicioLic",
      "FechaPonal",
      "FechaProcu",
    ];
  
    if (camposFecha.includes(campo)) {
      this.formData[campo] = fechaConvertida;
    }
  }
  

  withConfirmation() {
    this.validate = true;

    if (!this.formData.tipo) {
      this.errores.tipo = "Por favor, seleccione una opción.";
      if (!this.accordion.isExpanded("static-1")) {
        this.accordion.toggle("static-1");
      }
      setTimeout(() => {
        if (this.inputTipo) {
          this.inputTipo.nativeElement.focus();
          Swal.fire({
            title: "Campo requerido",
            text: "Seleccione un tipo de documento",
            icon: "info",
            confirmButtonText: "Aceptar",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
          });
        } else {
          console.log("Error: inputTipo no está disponible.");
        }
      });
      return;
    }

    if (!this.formData.cedula) {
      this.errores.cedula = "Por favor, ingresa un número de documento.";
      if (!this.accordion.isExpanded("static-1")) {
        this.accordion.toggle("static-1");
      }
      setTimeout(() => {
        if (this.inputCedula) {
          this.inputCedula.nativeElement.focus();
          Swal.fire({
            title: "Campo requerido",
            text: "Ingresar un número de documento",
            icon: "info",
            confirmButtonText: "Aceptar",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
          });
        } else {
          console.log("Error: inputCedula no está disponible.");
        }
      });
      return;
    }

    if (!this.formData.primernombre) {
      if (!this.accordion.isExpanded("static-1")) {
        this.accordion.toggle("static-1");
      }
      this.errores.primernombre = "Por favor, ingresa el nombre.";
      setTimeout(() => {
        if (this.inputPrimernombre) {
          this.inputPrimernombre.nativeElement.focus();
          Swal.fire({
            title: "Campo requerido",
            text: "Ingresar el primer nombre",
            icon: "info",
            confirmButtonText: "Aceptar",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
          });
        } else {
          console.log("Error: inputPrimernombre no está disponible.");
        }
      });
      return;
    }

    if (!this.formData.papellidos) {
      if (!this.accordion.isExpanded("static-1")) {
        this.accordion.toggle("static-1");
      }
      this.errores.papellidos = "Por favor, ingresa el primer apellido.";
      setTimeout(() => {
        if (this.inputPapellidos) {
          this.inputPapellidos.nativeElement.focus();
          Swal.fire({
            title: "Campo requerido",
            text: "Ingresa el primer apellido",
            icon: "info",
            confirmButtonText: "Aceptar",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
          });
        } else {
          console.log("Error: inputPapellidos no está disponible.");
        }
      });
      return;
    }

    if (!this.formData.fechanace) {
      this.errores.fechanace =
        "Por favor, seleccione una fecha de nacimiento.";
      if (!this.accordion.isExpanded("static-1")) {
        this.accordion.toggle("static-1");
      }
      setTimeout(() => {
        if (this.inputFechanacimiento) {
          this.inputFechanacimiento.nativeElement.focus();
          Swal.fire({
            title: "Campo requerido",
            text: "Seleccione una fecha de nacimiento",
            icon: "info",
            confirmButtonText: "Aceptar",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
          });
        } else {
          console.log("Error: inputFechanacimiento no está disponible.");
        }
      });
      return;
    }

    /* if (!this.formData.genero) {
      if (!this.accordion.isExpanded("static-1")) {
        this.accordion.toggle("static-1");
      }
      this.errores.genero = "Por favor, seleccione el genero.";
      setTimeout(() => {
        if (this.inputGenero) {
          this.inputGenero.nativeElement.focus();
          Swal.fire({
            title: "Campo requerido",
            text: "Seleccione el genero",
            icon: "info",
            confirmButtonText: "Aceptar",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
          });
        } else {
          console.log("Error: inputGenero no está disponible.");
        }
      });
      return;
    }
 */
   /*  if (!this.formData.civil) {
      if (!this.accordion.isExpanded("static-1")) {
        this.accordion.toggle("static-1");
      }
      this.errores.civil = "Por favor, seleccione el estado civil.";
      setTimeout(() => {
        if (this.inputEstadocivil) {
          this.inputEstadocivil.nativeElement.focus();
          Swal.fire({
            title: "Campo requerido",
            text: "Seleccione el estado civil",
            icon: "info",
            confirmButtonText: "Aceptar",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
          });
        } else {
          console.log("Error: inputEstadocivil no está disponible.");
        }
      });
      return;
    }

    if (!this.formData.estrato) {
      if (!this.accordion.isExpanded("static-1")) {
        this.accordion.toggle("static-1");
      }
      this.errores.estrato = "Por favor, seleccione el estrato social.";
      setTimeout(() => {
        if (this.inputEstratos) {
          this.inputEstratos.nativeElement.focus();
          Swal.fire({
            title: "Campo requerido",
            text: "Selecciona el estrato social",
            icon: "info",
            confirmButtonText: "Aceptar",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
          });
        } else {
          console.log("Error: inputEstratos no está disponible.");
        }
      });
      return;
    }

    if (!this.formData.raza) {
      if (!this.accordion.isExpanded("static-1")) {
        this.accordion.toggle("static-1");
      }
      this.errores.raza = "Por favor, seleccione la raza o grupo étnico:.";
      setTimeout(() => {
        if (this.inputRaza) {
          this.inputRaza.nativeElement.focus();
          Swal.fire({
            title: "Campo requerido",
            text: "Seleccione la raza o grupo étnico:",
            icon: "info",
            confirmButtonText: "Aceptar",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
          });
        } else {
          console.log("Error: inputRaza no está disponible.");
        }
      });
      return;
    }

    if (!this.formData.vivienda) {
      if (!this.accordion.isExpanded("static-1")) {
        this.accordion.toggle("static-1");
      }
      this.errores.vivienda = "Por favor, seleccione el tipo de vivienda.";
      setTimeout(() => {
        if (this.inputTipodevivienda) {
          this.inputTipodevivienda.nativeElement.focus();
          Swal.fire({
            title: "Campo requerido",
            text: "Seleccione el tipo de vivienda",
            icon: "info",
            confirmButtonText: "Aceptar",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
          });
        } else {
          console.log("Error: inputTipodevivienda no está disponible.");
        }
      });
      return;
    } */
    if (!this.formData.condicion) {
      if (!this.accordion.isExpanded("static-2")) {
        this.accordion.toggle("static-2");
      }
      this.errores.condicion = "Por favor, selecciona la condicion laboral.";
      setTimeout(() => {
        if (this.inputCondicion) {
          this.inputCondicion.nativeElement.focus();
          Swal.fire({
            title: "Campo requerido",
            text: "Selecciona la condicion laboral",
            icon: "info",
            confirmButtonText: "Aceptar",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
          });
        } else {
          console.log("Error: inputCondicion no está disponible.");
        }
      });
      return;
    }

    if (!this.formData.cargo) {
      if (!this.accordion.isExpanded("static-2")) {
        this.accordion.toggle("static-2");
      }
      this.errores.cargo = "Por favor, seleccione el cargo.";
      setTimeout(() => {
        if (this.inputCargos) {
          this.inputCargos.nativeElement.focus();
          Swal.fire({
            title: "Campo requerido",
            text: "Seleccione el cargo",
            icon: "info",
            confirmButtonText: "Aceptar",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
          });
        } else {
          console.log("Error: inputCargos no está disponible.");
        }
      });
      return;
    }

    if (this.formData.cargo === "2") {
    if (!this.formData.categoria) {
      if (!this.accordion.isExpanded("static-2")) {
        this.accordion.toggle("static-2");
      }
      this.errores.categoria = "Por favor, seleccione la categoria de licencia.";
      setTimeout(() => {
        if (this.inputCategoria) {
          this.inputCategoria.nativeElement.focus();
          Swal.fire({
            title: "Campo requerido",
            text: "Seleccione la categoria de licencia",
            icon: "info",
            confirmButtonText: "Aceptar",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
          });
        } else {
          console.log("Error: inputCategoria no está disponible.");
        }
      });
      return;
    }


    if (!this.formData.numerolic) {
      if (!this.accordion.isExpanded("static-2")) {
        this.accordion.toggle("static-2");
      }
      this.errores.numerolic = "Por favor, Ingresa el número de licencia.";
      setTimeout(() => {
        if (this.inputNumerolic) {
          this.inputNumerolic.nativeElement.focus();
          Swal.fire({
            title: "Campo requerido",
            text: "Ingresa el número de licencia",
            icon: "info",
            confirmButtonText: "Aceptar",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
          });
        } else {
          console.log("Error: inputNumerolic no está disponible.");
        }
      });
      return;
    }



    if (!this.formData.expediciolic) {
      if (!this.accordion.isExpanded("static-2")) {
        this.accordion.toggle("static-2");
      }
      this.errores.expediciolic = "Por favor, Seleccione la fecha de expedición.";
      setTimeout(() => {
        if (this.inputExpedicioLic) {
          this.inputExpedicioLic.nativeElement.focus();
          Swal.fire({
            title: "Campo requerido",
            text: "Seleccione la fecha de expedición",
            icon: "info",
            confirmButtonText: "Aceptar",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
          });
        } else {
          console.log("Error: inputExpedicioLic no está disponible.");
        }
      });
      return;
    }


    if (!this.formData.vencelic) {
      if (!this.accordion.isExpanded("static-2")) {
        this.accordion.toggle("static-2");
      }
      this.errores.vencelic = "Por favor, Seleccione la fecha de vencimiento.";
      setTimeout(() => {
        if (this.inputFechaVenceLic) {
          this.inputFechaVenceLic.nativeElement.focus();
          Swal.fire({
            title: "Campo requerido",
            text: "Seleccione la fecha de vencimiento",
            icon: "info",
            confirmButtonText: "Aceptar",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
          });
        } else {
          console.log("Error: inputFechaVenceLic no está disponible.");
        }
      });
      return;
    }
  }

    Swal.fire({
      title: "Confirmación",
      text: "¿Desea guardar la persona?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Guardar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        this.createPropietario();
      //  this.resetForm();
      }
    });

  }
  resetForm() {
    this.formData = {
      tipo: "",
      cedula: "",
      primernombre: "",
      papellidos: "",
      fechaCreacion: new Date(),
    };
    this.errores = {};
  }


  validarEnvio = false;

  
  validarCargo() {
    this.errores = {};
    this.validarEnvio = true;
    let esValido = true;
    let primerError = null;
  
    if (this.formData.cargo === "2") {
      if (!this.formData.categoria || this.formData.categoria.trim() === "") {
        this.errores.categoria = "Por favor, seleccione una categoría.";
        esValido = false;
        if (!primerError) primerError = "categoria";
      }
  
      if (!this.formData.numerolic || String(this.formData.numerolic).trim() === "") {
        this.errores.numerolic = "El Número de Licencia es obligatorio.";
        esValido = false;
        if (!primerError) primerError = "numerolic";
      }
  
      if (!this.formData.expediciolic || String(this.formData.expediciolic).trim() === "") {
        this.errores.expediciolic = "La Fecha de Expedición es obligatoria.";
        esValido = false;
        if (!primerError) primerError = "expediciolic";
      }
  
      if (!this.formData.vencelic || String(this.formData.vencelic).trim() === "") {
        this.errores.vencelic = "La Fecha de Vencimiento es obligatoria.";
        esValido = false;
        if (!primerError) primerError = "vencelic";
      }
    }
  
    if (!esValido) {
      setTimeout(() => {
        if (primerError === "categoria" && this.inputCategoria) {
          this.inputCategoria.nativeElement.focus();
          Swal.fire({
            title: "Campo requerido",
            text: "Por favor, seleccione una categoría.",
            icon: "info",
            confirmButtonText: "Aceptar",
            confirmButtonColor: "#3085d6",
          });
        } else if (primerError === "numerolic" && this.inputNumerolic) {
          this.inputNumerolic.nativeElement.focus();
          Swal.fire({
            title: "Campo requerido",
            text: "Ingrese un número de licencia.",
            icon: "info",
            confirmButtonText: "Aceptar",
            confirmButtonColor: "#3085d6",
          });
        } else if (primerError === "expediciolic" && this.inputExpedicioLic) {
          this.inputExpedicioLic.nativeElement.focus();
          Swal.fire({
            title: "Campo requerido",
            text: "Ingrese una fecha de expedición.",
            icon: "info",
            confirmButtonText: "Aceptar",
            confirmButtonColor: "#3085d6",
          });
        } else if (primerError === "vencelic" && this.inputFechaVenceLic) {
          this.inputFechaVenceLic.nativeElement.focus();
          Swal.fire({
            title: "Campo requerido",
            text: "Ingrese una fecha de vencimiento.",
            icon: "info",
            confirmButtonText: "Aceptar",
            confirmButtonColor: "#3085d6",
          });
        }
      });
  
      return false;
    }
  
    return true;
  }
  
  
  convertirFecha(fechaObj: any): string {
    if (typeof fechaObj === "string" && fechaObj.match(/^\d{4}-\d{2}-\d{2}$/)) {
      return fechaObj;
    }
  
    if (!fechaObj || !fechaObj.year || !fechaObj.month || !fechaObj.day) {
      console.error("Datos inválidos en fechaObj:", fechaObj);
      return "";
    }
  
    let year = fechaObj.year;
    let month = fechaObj.month;
    let day = fechaObj.day;
  
    const fechaHoy = new Date();
    const maxYear = fechaHoy.getFullYear();
    const maxMonth = 12;
    const maxDay = new Date(year, month, 0).getDate(); // Último día del mes
  
    if (year > maxYear) {
      console.error("El año ingresado es inválido.");
      alert(`Ingrese un año menor o igual a ${maxYear}.`);
      return "";
    }
    
    if (month > maxMonth || month < 1) {
      console.error("El mes ingresado es inválido.");
      alert("Ingrese un mes entre 01 y 12.");
      return "";
    }
  
    if (day > maxDay || day < 1) {
      console.error("El día ingresado es inválido.");
      alert(`Ingrese un día entre 01 y ${maxDay}.`);
      return "";
    }
  
    return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
  }

  validarCorreo() {
    const email = this.formData.mail?.trim(); // Evita errores si es null o undefined
  
    if (!email) {
      this.errores.mail = '';
      return;
    }
  
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  
    if (!emailRegex.test(email)) {
      this.errores.mail = 'Correo electrónico inválido.';
    } else {
      this.errores.mail = ''; // Correo válido
    }
  }
  

  guardar() {
    this.validarCorreo();
  
    if (this.errores.mail) {
      console.log('Corrige los errores antes de enviar.');
      return;
    }
  
  }

  obtenerTiposVivienda() {
    this.tipoViviendaService.getAll().subscribe(data => {
      console.log(data);
      this.TipoDeVivienda = data;
    });
  }

  // personas.component.ts
verificarCedula() {
  if (!this.formData.cedula) return;

  this.propietarioService.validarCedula(this.formData.cedula).subscribe(
    resp => {
      if (resp.existe) {
        this.errores.cedula = 'El documento ya existe';
       setTimeout(() => {
          this.inputCedula.nativeElement.focus();
        }, 0);
        
      } else {
        this.errores.cedula = false;
      }
    },
    err => {
      console.error('Error al validar la cédula', err);
    }
  );
}						  										 
   

  getTiposDocumento(): void {
    
this.tipoDocumentoService.getTiposDocumento().subscribe({
      next: (documento) => (this.Tiposdocumentos = documento),
      error: () =>
        this.mostrarAlerta(
          "Error",
          "No se pudieron cargar los tipos de documento",
          "error",
        ),
    });
  }

  private mostrarAlerta(titulo: string, mensaje: string, icono: any): void {
      Swal.fire({
        title: titulo,
        text: mensaje,
        icon: icono,
        confirmButtonColor: "#3085d6",
      });
    }

}
  
  